import { Record } from "immutable";

export const jobStateInfoFromJSON = (json: Partial<IJobStateInfoData>) => {
  const record: IJobStateInfoRecord = { ...(json as any) };

  return new JobStateInfoRecord(record);
};

export interface IJobStateInfoData {
  pretty_name: string;
  color: string;
}

export interface IJobStateInfoRecord {
  pretty_name: string;
  color: string;
}

export const defaultJobStateInfoRecord = {
  pretty_name: "",
  color: "",
};

export class JobStateInfoRecord extends Record(defaultJobStateInfoRecord) implements IJobStateInfoRecord {}
